import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import { ContragentService } from '@zaoblako/web/core/services/client/contragent.service';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';

@Component({
  standalone: true,
  selector: 'crm-contragent-auto-complete',
  templateUrl: './contragent-auto-complete.component.html',
  imports: [CommonModule, AutoCompleteComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContragentAutoCompleteComponent {
  @Input() public selectedContragent: ContragentFindInterface | OnlyIdRequiredInterface<ContragentFindInterface>;
  @Output() public selectedContragentChange = new EventEmitter<ContragentFindInterface>();

  @Input() public contragents: ContragentFindInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public inputStyleClass: string;
  @Input() public placeholder: string;
  @Input() public field = 'name';
  @Input() public disabled = false;
  @Input() public appendTo: string;
  @Input() public showClear = false;

  @Input() public clientId: number;
  @Input() public withBankDetails = false;
  @Input() public withClients = false;
  @Input() public withExternalUsers = false;

  @Input() public customSearch = true;
  @Output() public contragentSearch = new EventEmitter<string>();

  public constructor(
    private readonly contragentService: ContragentService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public toContragent(contragent: any): ContragentFindInterface {
    return contragent as ContragentFindInterface;
  }

  public searchContragent(name: string) {
    this.contragentService
      .search({
        search: name,
        clientIds: this.clientId ? [this.clientId] : [],
        withBankDetails: this.withBankDetails,
        withClients: this.withClients,
        withExternalUsers: this.withExternalUsers,
        withAdditionalInfo: true
      })
      .subscribe((contragents) => {
        this.contragents = contragents;
        this.cdRef.markForCheck();
      });
  }
}
